import React, { useState } from "react";
import {
  apiShape,
  intlShape,
  userShape,
  notifierShape,
  withApi,
  withIntl,
  withUser,
  withNotifier,
  Heading,
} from "lcm-iot-commons";

type Props = {
  api: apiShape;
  intl: intlShape;
  user: userShape;
  notifier: notifierShape;
};

export function NotificationEmailsHandler({
  api,
  intl,
  user,
  notifier,
}: Props) {
  const [state, setState] = useState({ value: false, health: false });

  const baseKey = "eh.pcps.user.notification_enabled.";
  const keySuffixes = {
    NOTIFICATION_VALUE: "value",
    NOTIFICATION_HEALTH: "health",
  };

  const loadNotificationSpecifications = async () => {
    try {
      const notificationSpecifications = await api.get(
        `/users/${user.id}/specifications`,
        { key: `${baseKey}*` },
      );
      const currentState = {};

      if (
        !notificationSpecifications[
          `${baseKey}${keySuffixes.NOTIFICATION_VALUE}`
        ]
      ) {
        const params = {};
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        params[`${baseKey}${keySuffixes.NOTIFICATION_VALUE}`] = {
          value: "true",
        };
        await api.patch(`/users/${user.id}/specifications`, params);
        (currentState as $TSFixMe).value = true;
      } else {
        (currentState as $TSFixMe).value =
          notificationSpecifications[
            `${baseKey}${keySuffixes.NOTIFICATION_VALUE}`
          ]?.value.toLowerCase() === "true";
      }

      if (
        !notificationSpecifications[
          `${baseKey}${keySuffixes.NOTIFICATION_HEALTH}`
        ]
      ) {
        const params = {};
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        params[`${baseKey}${keySuffixes.NOTIFICATION_HEALTH}`] = {
          value: "true",
        };
        await api.patch(`/users/${user.id}/specifications`, params);
        (currentState as $TSFixMe).health = true;
      } else {
        (currentState as $TSFixMe).health =
          notificationSpecifications[
            `${baseKey}${keySuffixes.NOTIFICATION_HEALTH}`
          ]?.value.toLowerCase() === "true";
      }

      // @ts-expect-error TS(2345) FIXME: Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
      setState(currentState);
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
  };

  React.useEffect(() => {
    loadNotificationSpecifications();
  }, []);

  const handleOnChange = async (type: $TSFixMe) => {
    try {
      const key = `${baseKey}${type}`;
      const params = {};
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      params[key] = { value: (!state[type]).toString() };
      await api.patch(`/users/${user.id}/specifications`, params);
      notifier.showSuccess(
        intl.formatMessage({
          id: "user_profile.notifications_success_notification",
        }),
      );
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      setState({ ...state, [type]: !state[type] });
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
  };

  return (
    <div id="notification-emails-group" className="notification-emails">
      <Heading
        id="user-profile-emails"
        level={3}
        title={intl.formatMessage({
          id: "user_profile.notification_emails_group",
        })}
      />
      <div id="notification-emails-activation-value">
        <input
          id="notification-value-emails"
          name="notification-value-emails"
          data-testid="notification-value-emails"
          type="checkbox"
          checked={state.value}
          onChange={() => handleOnChange("value")}
        />
        <label htmlFor="notification-value-emails">
          {intl.formatMessage({ id: "user_profile.notification_emails.value" })}
        </label>
      </div>
      <div id="notification-emails-activation-health">
        <input
          id="notification-health-emails"
          name="notification-health-emails"
          data-testid="notification-health-emails"
          type="checkbox"
          checked={state.health}
          onChange={() => handleOnChange("health")}
        />
        <label htmlFor="notification-health-emails">
          {intl.formatMessage({
            id: "user_profile.notification_emails.health",
          })}
        </label>
      </div>
    </div>
  );
}

export default withApi(
  withUser(withIntl(withNotifier(NotificationEmailsHandler))),
);
